module.exports = __webpack_public_path__ + "images/facility/image-coming-soon.png";